import { makeUclComponent } from '@fhs-legacy/universal-components';
import FullPageScreen from 'components/full-page-screen';

export const StyledFullPageScreen = makeUclComponent(FullPageScreen).withConfig({
  backgroundColor: Styles.color.background,
});
